import app from '@/app';

/* @ngInject */
function Iri($resource) {
	return $resource(
		'api/trs/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Tr', Iri);
